module.exports = __webpack_public_path__ + "assets/img/page4-nav-item-4-5c3850c9.png";